import React from 'react';

import ProfileNextToName from '../../../js/components/Profile/profileNextToName.js';

class ProfileNextToName2 extends React.Component {
	render() {
		return <ProfileNextToName obj={this.props.obj} />;
	}
}

export default ProfileNextToName2;
